'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function AuthHashRedirect() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hash = window.location?.hash;
    if (!hash) return;

    const params = new URLSearchParams(hash.slice(1));
    const accessToken = params?.get('access_token');
    const type = params?.get('type');

    if (accessToken && (type === 'recovery' || type === 'invite')) {
      router?.replace('/account-setup' + window.location?.hash);
    }
  }, [router]);

  return null;
}
